/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import { JobOrderMethod } from '../../jobs/orders';
import {
  CostCenterFinderListItemDto,
  CostCenterSupplierFinderListItemDto,
} from '../model/cost-center-list-item.dto';

export const CostCenterFinderListItemMapper = entity<CostCenterFinderListItemDto>({
  suppliers: arrayOf(subentity<CostCenterSupplierFinderListItemDto>({
    orderBy: enumeration(JobOrderMethod),
  })),
});
